export default "__VITE_ASSET__a8da0797__"